import React from 'react';
import ArrowSliderDark from '../images/slide-arrow.svg';
import ArrowSliderWhite from '../images/slide-arrow-white.svg';
import { joinClasses } from 'components/utils/react_helper';

export default function SliderArrow(props) {
  const { className, onClick, customClasses, color } = props;

  function arrowClasses() {
    return joinClasses([className ? className : null, customClasses ? customClasses : null]);
  }

  function imageClasses() {
    return joinClasses([`slick-arrow-image`, customClasses ? `${customClasses.split(' ')[0]}-image` : null]);
  }

  function arrowImage() {
    if (color == 'white') {
      return ArrowSliderWhite;
    }
    return ArrowSliderDark;
  }

  return (
    <div className={arrowClasses()} onClick={onClick}>
      <img className={imageClasses()} src={arrowImage()} alt="" />
    </div>
  );
}
